export default "__VITE_ASSET__CcjI0q79__"